/**
 * Utilitário para alertas sonoros no frontend
 */

let cachedAudio = null;

/**
 * Toca um chime harmonioso usando a Web Audio API como fallback de alta confiabilidade
 */
export const playSynthesizedChime = () => {
  try {
    const AudioContextClass = window.AudioContext || window.webkitAudioContext;
    if (!AudioContextClass) return;

    const ctx = new AudioContextClass();
    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }

    const notes = [
      { freq: 523.25, time: 0, duration: 0.3 }, // C5
      { freq: 659.25, time: 0.16, duration: 0.35 }, // E5
      { freq: 1046.5, time: 0.32, duration: 0.6 }, // C6
    ];

    notes.forEach(({ freq, time, duration }) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = 'sine';
      osc.frequency.setValueAtTime(freq, ctx.currentTime + time);

      gain.gain.setValueAtTime(0, ctx.currentTime + time);
      gain.gain.linearRampToValueAtTime(0.4, ctx.currentTime + time + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + time + duration);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start(ctx.currentTime + time);
      osc.stop(ctx.currentTime + time + duration);
    });
  } catch (e) {
    console.warn('[audioAlert] Falha ao tocar chime sintetizado:', e);
  }
};

/**
 * Toca o áudio padrão de aviso/decisão do SSE
 * @param {string} audioSrc Caminho relativo do áudio (padrão: /sound/alerta_decisao.wav)
 */
export const playDanfePromptAlert = (audioSrc = '/sound/alerta_decisao.wav') => {
  try {
    const soundUrl = audioSrc.startsWith('http') ? audioSrc : `${window.location.origin}${audioSrc}`;
    if (!cachedAudio || cachedAudio.src !== soundUrl) {
      cachedAudio = new Audio(soundUrl);
    }

    cachedAudio.currentTime = 0;
    const playPromise = cachedAudio.play();

    if (playPromise !== undefined) {
      playPromise.catch((err) => {
        console.warn('[audioAlert] Reprodução direta com arquivo falhou, acionando sintetizador:', err?.message || err);
        playSynthesizedChime();
      });
    }
  } catch (err) {
    console.warn('[audioAlert] Erro ao instanciar Audio, acionando sintetizador:', err);
    playSynthesizedChime();
  }
};
